export default "__VITE_ASSET__BPdYz2B7__"